import { CustomMenuItem } from '../../@core/components/ui/menu/menu.component';
import { FILE_TYPE } from '../../@core/models/enums';
import { IAttachment, IUser } from '../../@core/models/model';
import { DOCUMENT_MODEL, EMBEDDINGS_GENERATION_STATUS } from '../../contract-management/models/contract-management.model';
import { TOOLKIT_PROVIDERS } from './constants/tool.constants';
import { IThreadMetadata, LLM_PROVIDERS, THREAD_STREAMING_STATUS } from './models/model';

export enum CHECKPOINT_MODE {
    EDIT = 'EDIT',
    RETRY = 'RETRY',
}

export interface ChatMessagePayload {
    query: string
    provider: LLM_PROVIDERS
    attachments?: {
        _id: string
        docModel: DOCUMENT_MODEL
    }[]
    threadId?: string
    threadMetadataId?: string
    tools?: CustomMenuItem['selectionTree'][]
    messageId?: string  // For edit/retry functionality
    checkpointMode?: CHECKPOINT_MODE
    temp_id?: string;  // ✅ New field
    connectors?: TOOLKIT_PROVIDERS[]
    canvasId?: string;
    selectedCanvasText?: string;
    canvasName?: string;
    /** MongoDB _id of the library prompt being run — tells the backend to skip re-enhancement. */
    selectedPromptId?: string;
}

export enum PLAN_FEEDBACK {
    APPROVE = 'APPROVE',
    REJECT = 'REJECT',
}

export interface ChatAttachment {
    _id: string;
    docModel: DOCUMENT_MODEL;
    name: string;
    type: FILE_TYPE;
    attachmentData?: IAttachment;
    status?: EMBEDDINGS_GENERATION_STATUS;
    category?: string;
}

export enum QueryOptions {
    ADD_PHOTOS_AND_FILES = 'ADD_PHOTOS_AND_FILES',
    IMAGE_ANALYSIS = 'IMAGE_ANALYSIS',
    DEEP_RESEARCH = 'DEEP_RESEARCH',
    STUDY_AND_LEARN = 'STUDY_AND_LEARN',
    KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
    PROJECTS = 'PROJECTS',
    WEB_SEARCH = 'WEB_SEARCH',
    USE_STYLES = 'USE_STYLES',
    PROJECT_FILES = 'PROJECT_FILES',
    GOOGLE_DRIVE_FILES = 'GOOGLE_DRIVE_FILES',
    CUSTOM_INSTRUCTIONS = 'CUSTOM_INSTRUCTIONS',
    CANVAS = 'CANVAS',
    PROJECT_KNOWLEDGE = 'PROJECT_KNOWLEDGE',
}

export enum CHAT_STYLES {
    NORMAL = 'Normal',
    LEARNING = 'Learning',
    CONCISE = 'Concise',
    FORMAL = 'Formal',
    CASUAL = 'Casual',
    EXPLANATORY = 'Explanatory',
    BULLETS = 'Bullets',
    SUMMARIZE = 'Summarize',
}

export enum MESSAGE_FEEDBACK {
    LIKE = 'LIKE',
    DISLIKE = 'DISLIKE',
}

export interface IGeneralAgentChatResponse {
    status: THREAD_STREAMING_STATUS,
    threadId: string,
    threadMetadataId: string,
    messages: any[],

    // Retry/Edit fields
    isRetry?: boolean;
    editedMessageId?: string;
    editedMessageIndex?: number;
    clearFromIndex?: number;
    clearBeforeRetry?: boolean;

    // Action types
    action?: 'prepare_clear' | 'clear_and_prepare_retry' | 'retry_starting' | 'edited_message';
    keepMessagesBeforeIndex?: number;
    generated_files?: any[],

    // Provider info
    provider?: string;
    tokenCount?: number;
    input_tokens?: number;

    // Tool execution info
    tool_name?: string;
    tool_status?: 'started' | 'completed' | 'error';
    tool_id?: string; // Tool call ID for linking streaming content
    content?: string; // Streaming content for tool arguments (input_json_delta)
    file_path?: string; // File path for write_file tool
    error_message?: string;
}

export interface IMessageFeedback extends Document {
    threadId: string,

    messageId: string,
    feedback: MESSAGE_FEEDBACK,
    details: string,
    updatedBy: string | IUser,

    createdAt: Date,
    updatedAt: Date
}


export interface IMemoryContentItem {
    value: string;
    source_thread_id: string;
}

export interface IAgentMemory {
    _id: string,
    threadMetadataMap?: Record<string, IThreadMetadata>,
    namespace: string
    key: string,
    value: {
        content: IMemoryContentItem[],
        created_at: Date,
        updated_at: Date,
    }
    created_at: Date,
    updated_at: Date
}
